import React, { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './BrochurePdfModal.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

const BrochurePdfModal = ({ onClose, onHideForToday }) => {
  const [numPages, setNumPages] = useState(0);
  const [pageWidth, setPageWidth] = useState(900);
  const viewerRef = useRef(null);

  useEffect(() => {
    const resizePage = () => {
      if (!viewerRef.current) return;
      const width = viewerRef.current.clientWidth;
      const calculated = Math.floor(width - 36);
      setPageWidth(Math.max(120, Math.min(calculated, 900)));
    };

    resizePage();
    window.addEventListener('resize', resizePage);

    return () => {
      window.removeEventListener('resize', resizePage);
    };
  }, []);

  const onDocumentLoadSuccess = ({ numPages: loadedPages }) => {
    setNumPages(loadedPages);
  };

  return (
    <div className="brochure-modal" role="dialog" aria-modal="true" aria-label="브로셔">
      <div className="brochure-modal__header">
        <h2 className="brochure-modal__title">브로셔</h2>
        <button
          type="button"
          className="brochure-modal__close"
          onClick={onClose}
          aria-label="브로셔 닫기"
        >
          X
        </button>
      </div>

      <div className="brochure-modal__viewer" ref={viewerRef}>
        <Document
          file="/bruchure.pdf"
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<p className="brochure-modal__status">브로셔를 불러오는 중입니다...</p>}
          error={<p className="brochure-modal__status">브로셔를 불러오지 못했습니다.</p>}
        >
          <div className="brochure-modal__document">
            {Array.from({ length: numPages }, (_, index) => (
              <div className="brochure-modal__page" key={`page-${index + 1}`}>
                <Page pageNumber={index + 1} width={pageWidth} renderTextLayer={false} />
              </div>
            ))}
          </div>
        </Document>
      </div>
      <footer className="brochure-modal__footer">
        <button type="button" className="brochure-modal__hide-today" onClick={onHideForToday}>
          오늘 하루 보지 않기
        </button>
        <button type="button" className="brochure-modal__done" onClick={onClose}>
          닫기
        </button>
      </footer>
    </div>
  );
};

export default BrochurePdfModal;
